import { Component, Input } from '@angular/core';
import { PageHeaderComponent } from '../../../general-commons/components/page-header/page-header.component';

@Component({
  selector: 'stx-details-page',
  templateUrl: './details-page.component.html',
  styleUrls: ['./details-page.component.scss'],
  imports: [PageHeaderComponent]
})
export class DetailsPageComponent {
  @Input()
  pageTitleKey: string;
  @Input()
  name: string;
  @Input()
  localName: string;
}
